import React from "react";
import {Button} from "../controls";

import "./ErrorScreen.scss";

function ErrorScreen({title, children, buttonTitle, onButtonClick}) {
  return (
    <div className="c-errorscreen">
      <h1>{title}</h1>
      {children}
      <div className="c-errorscreen-actions">
      <Button onClick={onButtonClick}>{buttonTitle}</Button>
      </div>
    </div>
  )
}

export default ErrorScreen